import { render, staticRenderFns } from "./orderEtc.vue?vue&type=template&id=5f811a35&scoped=true&"
import script from "./orderEtc.vue?vue&type=script&lang=js&"
export * from "./orderEtc.vue?vue&type=script&lang=js&"
import style0 from "./orderEtc.vue?vue&type=style&index=0&id=5f811a35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f811a35",
  null
  
)

export default component.exports